<template>
  <div>
    <div class="container">
      <div class='reload'>
        <el-breadcrumb separator="/">
          <span class="leftLine"></span>
          <el-breadcrumb-item>代理商档案</el-breadcrumb-item>
          <el-breadcrumb-item>查看</el-breadcrumb-item>
        </el-breadcrumb>
        <el-button icon="el-icon-arrow-left"
                   size="mini"
                   @click="$router.back()">返回</el-button>
      </div>
      <div style="padding:20px;background:rgb(249,249,249)">
        <div class="formBox">
          <div class="form">
            <el-form ref="info"
                     :model="info"
                     label-position="left"
                     style="padding:20px;background:#fff"
                     label-width="180px">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="登记日期:">
                    {{info.registDate}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="所在省份:">
                    {{info.provinceName}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="代理商姓名/营业执照名称:">
                    {{info.agentName}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="代理商身份证号/营业执照号码:">
                    {{info.agentCard}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="代理商银行卡账户名称:">
                    {{info.bankAccountName}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="代理商银行卡开户行及支行:">
                    {{info.bankName}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收款账号:">
                    {{info.receivePaymentAccount}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="代理商手机号码:">
                    {{info.phoneNumber}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="代理商收件地址:">
                    {{info.receiveAddress}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="代理合同分成比例(%):">
                    {{info.contractRate}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="我方公司名称:">
                    {{info.ourCompanyName}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="开票信息:">
                    {{info.billInfo}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="上级代理商:">
                    {{info.superiorAgentName}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="销售负责人:">
                    {{info.saleName}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import { getAgent } from '../../API'
    import { parantId } from '../../util/parantId'
    import { show } from '../../util/show'
    import exportMethod from '../../util/util'
    export default {
        data(){
            return{
                info:{},
                tableData:[
                    {name:1}
                ]
            }
        },
        created(){
            getAgent(localStorage.getItem('agentInfoId')).then(res=>{
                if(res.code===0){
                    this.info=res.data
                    console.log(this.info)
                }
            })
        }
    }
</script>

<style lang='less' scoped>
  .header {
    height: 50px;
    line-height: 50px;
    background: rgb(243, 243, 243);
    padding: 0 20px;
    border: 1px solid rgba(228, 228, 228, 1);
  }
  .reload {
    background-color: rgba(236, 240, 245, 1);
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    font-weight: 650;
    font-style: normal;
    font-size: 24px;
    color: #3498db;
  }
  .formBox {
    border: 1px solid #e4e4e4;
    border-top: 7px solid #3498db;
  }
  /deep/ .el-breadcrumb__item {
    float: none;
  }
  .container {
    border: none;
    background-color: rgba(236, 240, 245, 1);
    padding: 0 0;
  }
  /deep/ .el-input{
    width: 200px;
  }
  .leftLine {
    border-left: 5px solid rgba(52, 152, 219, 1);
    padding-right: 10px;
  }

  .form {
    background-color: #fff;
    border: 1px solid rgba(228, 228, 228, 1);
    padding: 20px;
  }
  .el-breadcrumb {
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    color: #999;
    background-color: rgba(236, 240, 245, 1);
  }
  .header {
    font-weight: 700;
    font-style: normal;
    color: #5e5e5e;
  }
  .ax_default {
    font-family: "ArialMT", "Arial";
    font-weight: 400;
    font-style: normal;
    font-size: 13px;
    border-bottom: 1px solid#333333;
    text-align: center;
    line-height: normal;
  }
  .line1 {
    height: 1px;
    margin-bottom: 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  .pagination {
    float: right;
    /deep/ .el-pagination.is-background .btn-prev:disabled {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-prev {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-next:disabled {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .btn-next {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .el-pager li {
      background: #fff;
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #409eff;
    }
  }
</style>
